/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_CLIP_ICON': {
    width: 16,
    height: 16,
    viewBox: '4.1 5 17.1 15.5',
    data: '<path pid="0" d="M20 6.2c-.6-.6-1.5-1-2.3-1-.9 0-1.7.3-2.3 1l-1.2 1.2L5 16.5c-.9.9-.9 2.3 0 3.2.4.4 1 .7 1.6.7s1.1-.2 1.6-.7l7-7 3.3-3.3c.5-.5.5-1.4 0-2-.5-.5-1.4-.5-2 0l-6.3 6.3c-.1.1-.1.3 0 .4 0 0 .1.1.2.1s.1 0 .2-.1l6.3-6.3c.3-.3.9-.3 1.3 0 .3.3.3.9 0 1.3L17 10.2l-2.1 2.1-1 1-6 6c-.8.7-1.9.7-2.5 0-.4-.3-.6-.7-.6-1.2s.2-.9.5-1.2l.5-.5 9.8-9.8c.5-.5 1.2-.8 2-.8s1.5.3 2 .8c1.1 1.1 1.1 2.9 0 4l-8.2 8.2c-.1.1-.1.3 0 .4 0 0 .1.1.2.1s.1 0 .2-.1L20 11c1.3-1.4 1.3-3.5 0-4.8z" _fill="currentColor"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_CLIP_ICON.js